import type { PublicSlotKey } from '#packages/apilib';
import type { ImageToBackgroundPublicApi } from './api';

export const ImageToBackgroundApiKey: PublicSlotKey<ImageToBackgroundPublicApi> =
  {
    name: 'ImageToBackgroundPackageApi',
    public: true,
  };
